"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwoColumnTableCell = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const StyledTwoColumnTableCell = components_core_1.styled.td `
  padding: ${props => props.theme.size.static150} 0;
  border-bottom: 1px solid ${props => props.theme.colors.border.divider};
  width: 50%;
`;
function TwoColumnTableCell({ children }) {
    return (react_1.default.createElement(StyledTwoColumnTableCell, { className: "two-column-table-container" }, children));
}
exports.TwoColumnTableCell = TwoColumnTableCell;
